
export default function Footer() {
  return (
    <footer className="bg-white text-[#1E3A5F] py-12 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <img 
              src="https://static.readdy.ai/image/0eb722bc6d334a4c0ff7cf36fa5a7e2c/6231b55b65561184d9e387b98fd52d79.png" 
              alt="Reda & Naoual Logo" 
              className="h-16 w-auto mb-4"
            />
            <p className="text-gray-600 leading-relaxed">
              Plus de 20 ans d'excellence dans la fabrication de solutions métalliques sur mesure.
            </p>
          </div>

          <div>
            <h4 className="text-xl font-bold mb-4 text-[#1E3A5F]">Liens rapides</h4>
            <ul className="space-y-2">
              <li>
                <a href="#home" className="text-gray-600 hover:text-[#A83232] transition-colors cursor-pointer">
                  Accueil
                </a>
              </li>
              <li>
                <a href="#introduction" className="text-gray-600 hover:text-[#A83232] transition-colors cursor-pointer">
                  À Propos
                </a>
              </li>
              <li>
                <a href="#products" className="text-gray-600 hover:text-[#A83232] transition-colors cursor-pointer">
                  Produits
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-600 hover:text-[#A83232] transition-colors cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xl font-bold mb-4 text-[#1E3A5F]">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-[#A83232] mt-1"></i>
                <span className="text-gray-600">Taza, Maroc</span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-phone-line text-[#A83232] mt-1"></i>
                <div className="text-gray-600">
                  <div>+212 677 76 48 67</div>
                  <div>+212 661 91 88 21</div>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-mail-line text-[#A83232] mt-1"></i>
                <span className="text-gray-600">steredanaoual@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8 text-center">
          <p className="text-gray-600">
            © {new Date().getFullYear()} Reda & Naoual - Art du Métal. Tous droits réservés.
          </p>
          <p className="text-gray-500 mt-2">
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-[#A83232] transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
